'use client';

import { emptyLabel } from "./Select.data.js";
const defaultProps = {
  emptyLabel
};
export {
  defaultProps
};
